import { useEffect, useState } from "react";
import SiteHeader from "@/pages/home/components/SiteHeader";
import HeroSection from "@/pages/home/components/HeroSection";
import TickerBar from "@/pages/home/components/TickerBar";
import EntryChannels from "@/pages/home/components/EntryChannels";
import TopicWall from "@/pages/home/components/TopicWall";
import FeedSection from "@/pages/home/components/FeedSection";
import DiscussionWall from "@/pages/home/components/DiscussionWall";
import ContactSection from "@/pages/home/components/ContactSection";
import SubmitGuide from "@/pages/home/components/SubmitGuide";
import FaqSection from "@/pages/home/components/FaqSection";
import SiteFooter from "@/pages/home/components/SiteFooter";

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-screen w-full bg-background-50 overflow-x-hidden">
      <SiteHeader />

      <main className="w-full">
        <HeroSection />
        <TickerBar />
        <EntryChannels />
        <TopicWall />
        <FeedSection />
        <DiscussionWall />
        <ContactSection />
        <SubmitGuide />
        <FaqSection />
      </main>

      <SiteFooter />

      {showTop && (
        <button
          type="button"
          aria-label="返回顶部"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className="fixed bottom-6 right-5 md:bottom-8 md:right-8 z-40 w-11 h-11 md:w-12 md:h-12 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 flex items-center justify-center text-xl transition-colors cursor-pointer"
        >
          <i className="ri-arrow-up-line"></i>
        </button>
      )}
    </div>
  );
}